import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const VOWEL_COMBO_LAUNCH_ACTIVITY_FRAGMENT = gql `
  fragment VowelComboLaunchActivityFragment on VowelComboLaunchActivity {
    rounds {
      id
      steps {
        id
        isLeft
        prefix
        suffix
        vowels
        answerAudio {
          id
          audio {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default VOWEL_COMBO_LAUNCH_ACTIVITY_FRAGMENT;
